import { guideSteps, tips } from "@/mocks/portal";

export default function QuickGuide() {
  return (
    <section id="guide" className="mx-auto max-w-[1200px] scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
        {/* 指南步骤 */}
        <div>
          <span className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600">
            <i className="ri-book-open-line text-sm" aria-hidden="true" />
            Quick Start
          </span>
          <h2 className="mt-1 text-lg font-bold text-foreground-950 md:text-2xl">切换指南 · 四步上手</h2>
          <p className="mt-1 text-xs text-foreground-500 md:text-sm">把“换线=换手感”拆成四个可复查的动作，每一步都有明确的线路对比依据。</p>

          <ol className="mt-6 flex flex-col gap-4">
            {guideSteps.map((s) => (
              <li key={s.step} className="flex items-start gap-4 rounded-xl border border-background-200 bg-background-100 p-4">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-primary-500 text-background-50">
                  <i className={`${s.icon} text-xl`} aria-hidden="true" />
                </span>
                <div className="min-w-0">
                  <p className="flex flex-wrap items-center gap-2 text-sm font-bold text-foreground-950">
                    <span className="font-num text-[11px] font-bold text-primary-500">{s.step}</span>
                    {s.title}
                  </p>
                  <p className="mt-1 text-[13px] leading-6 text-foreground-600">{s.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>

        {/* 技巧 */}
        <div>
          <span className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
            <i className="ri-lightbulb-flash-line text-sm" aria-hidden="true" />
            Field Notes
          </span>
          <h2 className="mt-1 text-lg font-bold text-foreground-950 md:text-2xl">别人踩过的坑，先替你标注</h2>
          <p className="mt-1 text-xs text-foreground-500 md:text-sm">几条来自社区复盘的小规律，帮你做多线选择时少走弯路。</p>

          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {tips.map((t) => (
              <div key={t.title} className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300">
                <div className="flex items-center gap-2.5">
                  <span className="grid h-9 w-9 place-items-center rounded-lg bg-accent-100 text-accent-600">
                    <i className={`${t.icon} text-lg`} aria-hidden="true" />
                  </span>
                  <h3 className="text-sm font-bold text-foreground-950">{t.title}</h3>
                </div>
                <p className="mt-2.5 text-[13px] leading-6 text-foreground-600">{t.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}